<!-- notfound section -->
<section class="waypoint-tigger xs-section-padding">
  <div class="container">
    <div class="xs-heading row xs-mb-60 justify-content-center text-center">
      <div class="col-md-6 col-xl-6">
        <img
          src="/assets/images/page-not-found.png"
          alt=""
          width="450"
          height="450"
        />
        <h2 class="xs-title">Oops!</h2>
        <p>There is something wrong with the page. I cannot find it.</p>
        <a href="/" class="btn btn-primary mt-4">Back to the home page</a>
      </div>
      <!-- .xs-heading-title END -->
    </div>
    <!-- .row end -->
  </div>
  <!-- .container end -->
</section>
<!-- End notfound section -->
